import { render, staticRenderFns } from "./MarketSummary.vue?vue&type=template&id=12f9f258&scoped=true&"
import script from "./MarketSummary.vue?vue&type=script&lang=js&"
export * from "./MarketSummary.vue?vue&type=script&lang=js&"
import style0 from "./MarketSummary.vue?vue&type=style&index=0&id=12f9f258&scoped=true&lang=css&"
import style1 from "./MarketSummary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9f258",
  null
  
)

export default component.exports